<script setup>
  import { ref } from 'vue';

  import { useUserStore } from '@/stores/UserStore';
  
  const saveContainerStep = defineModel('saveContainerStep', { default: 1 });
  const savedContainerName = defineModel('savedContainerName');

  const props = defineProps({
    containerTypeId: {
      type: String,
      required: false
    },  
    containerTypeName: {
      type: String,
      required: false
    },  
    settings: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    }
  });

  const userStore = useUserStore();

  const autoSavedsectionId = ref(null);

  async function handleGoToNextStep() {
    if (userStore.userProfiles.profiles.length === 1) {
      const profileId = userStore.userProfiles.profiles[0].profile_id;
      const data = await userStore.addContainerToProfile(profileId, props.containerTypeId, savedContainerName.value, props.settings);
      await userStore.getProfiles(true);

      if (data.status_code === 0) {
        autoSavedsectionId.value = data.status_message;
      }
    }

    saveContainerStep.value = 2;
  }
</script>

<template>
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Save {{ props.containerTypeName }}?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-modal__form-control">
          <label for="container-name" class="jwx-modal__control-label">Name</label>
          <input
            v-model="savedContainerName"
            type="text"
            id="container-name"
            name="container-name"
            class="jwx-modal__input" />
        </div>
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Cancel
      </button>
        <button 
          type="button" 
          @click.prevent="handleGoToNextStep"
          class="jwx-button jwx-button--success"
        >
          Next
        </button>
      </div>
    </div>
</template>